import React from "react";
import PropTypes from "prop-types";
import LightBulbSvg from "components/SvgComponents/LightBulbSvg";
import LightPoleSvg from "components/SvgComponents/LightPoleSvg";
import ReportsSvg from "components/SvgComponents/ReportsSvg";
// import WorkerSvg from "components/SvgComponents/WorkerSvg";
import SelectionSvg from "components/SvgComponents/SelectionSvg";
// import PaletteSvg from "components/SvgComponents/PaletteSvg";
import ReplaceSvg from "components/SvgComponents/ReplaceSvg";
import InstallSvg from "components/SvgComponents/InstallSvg";
import FileSvg from "components/SvgComponents/FileSvg";

export default function ToolBar(props) {
  const { selectedTool, handleChangeSelectedTool } = props;
  return (
    <ul className="tool__bar list-unstyled">
      <li>
        <button
          className={`${
            selectedTool === "polesSelection" ? "active" : ""
          } custom_tooltip`}
          data-tool="polesSelection"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <SelectionSvg />
          <span className="tooltiptext" data-tool="polesSelection">
            Job Zones
          </span>
        </button>
      </li>
      {/* <li>
        <button
          className={`${selectedTool === "paletteTracking" ? "active" : ""}`}
          data-tool="paletteTracking"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <PaletteSvg />
        </button>
      </li> */}
      <li>
        <button
          className={`${
            selectedTool === "unitsReport" ? "active" : ""
          } custom_tooltip`}
          data-tool="unitsReport"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <LightBulbSvg />
          <span className="tooltiptext" data-tool="unitsReport">
            Units Report
          </span>
        </button>
      </li>
      <li>
        <button
          className={`${
            selectedTool === "unitsHistoryReport" ? "active" : ""
          } custom_tooltip`}
          data-tool="unitsHistoryReport"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <ReportsSvg />
          <span className="tooltiptext" data-tool="unitsHistoryReport">
            Units History Report
          </span>
        </button>
      </li>
      <li>
        <button
          className={`${
            selectedTool === "polesReport" ? "active" : ""
          } custom_tooltip`}
          data-tool="polesReport"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <LightPoleSvg />
          <span className="tooltiptext" data-tool="polesReport">
            Poles Report
          </span>
        </button>
      </li>
      <li>
        <button
          className={`${
            selectedTool === "removedUnitsReport" ? "active" : ""
          } custom_tooltip`}
          data-tool="removedUnitsReport"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <ReplaceSvg />
          <span className="tooltiptext" data-tool="removedUnitsReport">
            Removed Units Report
          </span>
        </button>
      </li>
      <li>
        <button
          className={`${
            selectedTool === "installationReport" ? "active" : ""
          } custom_tooltip`}
          data-tool="installationReport"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <InstallSvg />
          <span className="tooltiptext" data-tool="installationReport">
            Installation Report
          </span>
        </button>
      </li>
      <li>
        <button
          className={`${
            selectedTool === "handoverReports" ? "active" : ""
          } custom_tooltip`}
          data-tool="handoverReports"
          type="button"
          onClick={handleChangeSelectedTool}
        >
          <FileSvg />
          <span className="tooltiptext" data-tool="handoverReports">
            Handover Report
          </span>
        </button>
      </li>
    </ul>
  );
}

ToolBar.propTypes = {
  selectedTool: PropTypes.string.isRequired,
  handleChangeSelectedTool: PropTypes.func.isRequired,
};
